import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';

export type TravelExpensesOpenStatus = 'open' | 'closed' | null;

export type ITravelExpensesOpenStatusPickerProps = {
  value: TravelExpensesOpenStatus;
  onChange: (value: TravelExpensesOpenStatus) => void;
};

export function TravelExpensesOpenStatusPicker(
  props: ITravelExpensesOpenStatusPickerProps
) {
  const { value: valueProp, onChange } = props;

  const { t } = useTranslation();

  const dataSet = useMemo(() => {
    return [
      {
        id: 'open',
        name: t('COMMON.TRAVELEXPENSES_OPEN_STATUS_OPEN'),
      },
      {
        id: 'closed',
        name: t('COMMON.TRAVELEXPENSES_OPEN_STATUS_CLOSED'),
      },
    ];
  }, [t]);

  const value = useMemo(() => {
    return dataSet.find((item) => item.id === String(valueProp));
  }, [valueProp, dataSet]);

  return (
    <FixedDataPicker
      multiple={false}
      value={value}
      dataSet={dataSet}
      clearable={false}
      onChange={(value) => {
        onChange(value.id as TravelExpensesOpenStatus);
      }}
    />
  );
}
